import { canAccessInternalNonProductionFeature } from '@advania-cosoftware/wolf-core';

export function showItFinancialsV2Navigation(
    user: Parameters<typeof canAccessInternalNonProductionFeature>[0],
    hostname: string,
    itFinancialsAvailable: boolean,
): boolean {
    return itFinancialsAvailable && canAccessInternalNonProductionFeature(user, hostname);
}
